import React from "react";
import HealthAreaComponent from "../../components/mosaic/HealthAreaCategories";

const HealthAreaPage: React.FC = () => {
  return <HealthAreaComponent />;
};

export default HealthAreaPage;
